import script from "./PaymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentForm.vue?vue&type=script&setup=true&lang=js"

import "./PaymentForm.vue?vue&type=style&index=0&id=e87fc62c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e87fc62c"]])

export default __exports__